"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = tslib_1.__importDefault(require("@tippy.js/react"));
class AjaxButtonClass extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.ref = react_1.default.createRef();
        this.noButtonRef = react_1.default.createRef();
        this.state = {
            confirmationPopOverIsOpen: false,
            errorBuffer: false,
            hasValidatedOnce: false,
            isPopOverOpen: false,
            successBuffer: false,
        };
    }
    componentDidUpdate(prevProps) {
        // Clear the error and success buffers when the error status has changed after an initial buffer:
        // TODO: This feels wrong, can we improve this?
        if (prevProps.error !== this.props.error &&
            this.state.errorBuffer !== true) {
            if (this.errorBufferTimeout) {
                clearTimeout(this.errorBufferTimeout);
            }
            if (this.successBufferTimeout) {
                clearTimeout(this.successBufferTimeout);
            }
            // Perhaps this can go in getDerivedState ?
            this.setState({
                errorBuffer: true,
                successBuffer: false,
            }, () => {
                this.errorBufferTimeout = setTimeout(() => {
                    this.setState({
                        errorBuffer: false,
                    });
                }, 1 * 2000);
            });
        }
        // Clear the error and success buffers when the success status has changed after an initial buffer:
        // TODO: This feels wrong, can we improve this?
        if (prevProps.success !== this.props.success &&
            this.state.successBuffer !== true) {
            if (this.errorBufferTimeout) {
                clearTimeout(this.errorBufferTimeout);
            }
            if (this.successBufferTimeout) {
                clearTimeout(this.successBufferTimeout);
            }
            // Perhaps this can go in getDerivedState ?
            this.setState({
                errorBuffer: false,
                successBuffer: true,
            }, () => {
                this.successBufferTimeout = setTimeout(() => {
                    this.setState({
                        successBuffer: false,
                    });
                }, 1 * 2000);
            });
        }
    }
    render() {
        const { id, icon, type, isLink, size, label, color, formik, loading, disabled, popoverBody, onMouseOver, onMouseOut, successText, loadingClassName, successClassName, failedClassName, defaultStateClassName, loadingText, onConfirmation, showValidationPopover, confirmationMessage, iconRight, iconClassName, confirmationYesMessage, confirmationNoMessage, confirmationFinePrint, outline, style, iconProps, } = this.props;
        const { errorBuffer, successBuffer, confirmationPopOverIsOpen, } = this.state;
        let newColor = color || 'success';
        let iconNode;
        let buttonLabel = label;
        let popover = popoverBody;
        if (formik &&
            showValidationPopover &&
            !popoverBody &&
            formik.errors &&
            Object.keys(formik.errors).length !== 0) {
            const renderErrors = (errors) => (react_1.default.createElement("ul", { className: "list-unstyled m-2 mt-0" }, Object.entries(errors).map(error => {
                if (!error[1]) {
                    return null;
                }
                return (react_1.default.createElement("li", { key: error[0] },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle, className: "text-danger mr-2" }),
                    react_1.default.createElement("strong", null,
                        this.props.humanFieldNames &&
                            this.props.humanFieldNames[error[0]]
                            ? `${this.props.humanFieldNames[error[0]]}`
                            : error[0][0].toUpperCase() + error[0].slice(1),
                        ":"),
                    ' ',
                    typeof error[1] === 'undefined'
                        ? ''
                        : error[1] instanceof Object
                            ? renderErrors(error[1])
                            : `${error[1]}`));
            })));
            popover = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "You cannot save until you correct these errors:"),
                renderErrors(formik.errors)));
        }
        if (!popover && onConfirmation && confirmationPopOverIsOpen) {
            popover = (react_1.default.createElement("div", { className: "p-2" },
                react_1.default.createElement("p", { className: "lead text-center", style: { minWidth: 160 } }, confirmationMessage || 'Are you sure?'),
                react_1.default.createElement("div", { className: "w-100 mt-2 d-flex flex-row" },
                    react_1.default.createElement(reactstrap_1.Button, { color: "danger", size: "sm", className: "flew-grow-1 w-100", onClick: () => {
                            this.setState({
                                confirmationPopOverIsOpen: false,
                                isPopOverOpen: false,
                            }, () => {
                                onConfirmation();
                            });
                        } }, confirmationYesMessage || 'Yes'),
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", className: "ml-2 flew-grow-1 w-100", onClick: () => {
                            this.setState({
                                confirmationPopOverIsOpen: false,
                                isPopOverOpen: false,
                            });
                        }, innerRef: this.noButtonRef }, confirmationNoMessage || 'No')),
                confirmationFinePrint && (react_1.default.createElement(reactstrap_1.FormText, { className: "mb-0 mt-2 text-center" }, confirmationFinePrint))));
        }
        // Show loading state
        const iconClassNames = (hasButtonLabel) => classnames_1.default({
            'ml-2': hasButtonLabel && iconRight,
            'mr-2': hasButtonLabel && !iconRight,
        }, iconClassName);
        if (loading) {
            buttonLabel = loadingText || 'Loading...';
            iconNode = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true, className: iconClassNames(!!buttonLabel) }, iconProps)));
            // Show error state
        }
        else if (errorBuffer) {
            buttonLabel = 'Failed';
            newColor = 'danger';
            iconNode = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: pro_solid_svg_icons_1.faExclamationTriangle, className: iconClassNames(!!buttonLabel) }, iconProps)));
            // Show success state
        }
        else if (successBuffer) {
            buttonLabel = successText || 'Success';
            newColor = 'success';
            iconNode = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: pro_solid_svg_icons_1.faCheck, className: iconClassNames(!!buttonLabel) }, iconProps)));
            // If it's the normal state and there is an error, show it
        }
        else if (icon) {
            iconNode = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: icon, className: iconClassNames(!!buttonLabel) }, iconProps)));
        }
        const isDisabled = disabled || loading || errorBuffer || successBuffer;
        const commonProps = {
            className: classnames_1.default({
                btn: !isLink,
                [`btn-${newColor}`]: !outline && !isLink && !!newColor,
                [`btn-${size}`]: !isLink && !!size,
                [`btn-outline-${newColor || 'primary'}`]: !!outline,
                'btn-disabled': isDisabled,
            }, {
                'progress-bar-striped progress-bar-animated': !isLink && (loading || errorBuffer),
            }, this.props.className, {
                [defaultStateClassName]: !loading && !successBuffer && !errorBuffer,
                [failedClassName]: errorBuffer,
                [loadingClassName]: loading,
                [successClassName]: successBuffer,
            }),
            disabled: disabled || loading || errorBuffer || successBuffer,
            href: isLink ? '#' : undefined,
            id: id ? id.toString() : undefined,
            onClick: () => {
                if (this.props.onConfirmation) {
                    this.setState({
                        confirmationPopOverIsOpen: true,
                        isPopOverOpen: true,
                    }, () => {
                        if (this.noButtonRef.current) {
                            setTimeout(() => {
                                if (this.noButtonRef.current &&
                                    this.noButtonRef.current.focus) {
                                    this.noButtonRef.current.focus();
                                }
                            }, 100);
                        }
                    });
                }
                else if (this.props.onClick) {
                    this.props.onClick();
                }
            },
            onMouseOut: () => {
                if (!this.state.confirmationPopOverIsOpen) {
                    this.setState({
                        isPopOverOpen: false,
                    }, () => {
                        if (onMouseOut) {
                            onMouseOut();
                        }
                    });
                }
            },
            onMouseOver: () => {
                if (onMouseOver) {
                    onMouseOver();
                }
                // This is a little hack because Formik doesn't validate on initialize.
                // This runs a validation.
                if (formik && formik.validateForm && !this.state.hasValidatedOnce) {
                    formik.validateForm();
                    this.setState({
                        hasValidatedOnce: true,
                    });
                }
                if (!this.state.confirmationPopOverIsOpen) {
                    this.setState({
                        isPopOverOpen: true,
                    });
                }
            },
            ref: this.ref,
            style,
            tag: isLink ? 'a' : undefined,
            type: type || 'button',
        };
        const tag = (children) => !isLink ? (react_1.default.createElement("button", Object.assign({ "data-cy": this.props['data-cy'] || 'ajax-btn' }, commonProps, { type: type }), children)) : (react_1.default.createElement("a", Object.assign({}, commonProps), children));
        const comp = tag(react_1.default.createElement(react_1.default.Fragment, null,
            !iconRight && iconNode,
            buttonLabel,
            iconRight && iconNode));
        if (!popover) {
            return comp;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.default
            // target={this.ref.current}
            // placement="auto"
            // isOpen={popoverIsOpen}
            , { 
                // target={this.ref.current}
                // placement="auto"
                // isOpen={popoverIsOpen}
                interactive: true, content: react_1.default.createElement(react_1.default.Fragment, null, popover) }, comp)));
    }
}
exports.AjaxButton = formik_1.connect((props) => (react_1.default.createElement(AjaxButtonClass, Object.assign({}, props))));
//# sourceMappingURL=AjaxButton.js.map